import { Box, Typography, Button, SxProps, Theme } from "@mui/material";
import React from "react";

import { useCelleraTheme } from "theme/useCelleraTheme";

interface SectionWrapperProps {
  title: string;
  onViewAll?: () => void;
  children: React.ReactNode;
  spacing?: "normal" | "compact";
  sx?: SxProps<Theme>;
}

const SectionWrapper: React.FC<SectionWrapperProps> = ({
  title,
  onViewAll,
  children,
  spacing = "normal",
  sx,
}) => {
  const { colors } = useCelleraTheme();

  return (
    <Box sx={{ mb: spacing === "compact" ? 1 : 2, ...sx }}>
      {/* Section Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography
            sx={{
              fontWeight: 500,
              color: colors.text.primary,
            }}
          >
            {title}
          </Typography>
        </Box>
        {onViewAll && (
          <Button
            onClick={onViewAll}
            className="font-medium text-xs leading-4 tracking-wider normal-case"
            sx={{
              color: colors.primary.main,
              "&:hover": {
                backgroundColor: colors.primary.light,
              },
            }}
          >
            View All
          </Button>
        )}
      </Box>

      {/* Section Content - Show only first 3 items */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: 2,
        }}
      >
        {React.Children.toArray(children).slice(0, 3)}
      </Box>
    </Box>
  );
};

export default SectionWrapper;
